import {html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {query} from "lit/decorators/query.js";
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import "@/components/loading-animation/loading-animation"
import "@/components/ch-load-more-teaser/ch-load-more-teaser.scss"

@customElement('sbk-ch-load-more-teaser')
export class SbkChLoadMoreTeaser extends LitElement {

    @property({attribute: 'button-label'})
    buttonLabel: string = '';

    @property({type: Number, attribute: 'page-id'})
    pageId: number = 0;

    @property({type: Number, attribute: 'initial-teaser-amount'})
    initialTeaserAmount: number = 0;

    @property({type: Number, attribute: 'teaser-per-reload'})
    teaserPerReload: number = 3;

    @property({type: Number, attribute: 'teaser-initial-items'})
    teaserInitialItems: number = 0;


    @property({attribute: 'teaser-ids'})
    teaserIds: string = '';

    @property()
    category: string = '';

    @query('.teaser-container')
    _teaserContainer!: HTMLDivElement;

    _teaser: Array<string> = [];

    @state()
    _teaserLoadList: Array<number> = [];

    @state()
    _isLoading: boolean = false;

    render() {
        return html`
            <div class="teaser-container row">
                ${this.renderTeaser()}
            </div>
            <div class="align-center">
                ${this._isLoading ?
                        html`
                            <sbk-loading-animation></sbk-loading-animation>` :
                        html`
                            <sbk-button @click=${this._loadMore} variant="secondary">
                                ${this.buttonLabel}
                            </sbk-button>`}
            </div>
        `;
    }

    renderTeaser() {
        if (!this._teaser.length) {
            return '';
        }
        return html`
            ${this._teaser.map((teaser) => html`
                <div class="col-sm-12 col-md-6 col-lg-6 ${this.teaserPerReload === 3 ? 'col-xl-4' : 'col-xl-3'}">
                    ${unsafeHTML(teaser)}
                </div>
            `)}
        `;
    }

    connectedCallback() {
        super.connectedCallback();
        this._teaserLoadList = JSON.parse(this.teaserIds);
    }

    createRenderRoot() {
        return this;
    }

    private _loadMore() {
        const nextTeaser = this._teaserLoadList.slice(this.teaserInitialItems, this.teaserPerReload + this.teaserInitialItems);
        const fetchPromises: Promise<string>[] = [];
        nextTeaser.forEach(teaserId => {
            const url = `?id=${teaserId}&category=${this.category}&type=3002`;
            fetchPromises.push(fetch(url).then(response => response.text()));
        });
        this._isLoading = true
        Promise.all(fetchPromises)
            .then(results => {
                results.forEach(result => {
                    this._teaser.push(result)
                })
                this._teaserLoadList.splice(this.teaserInitialItems, this.teaserPerReload);
                this._isLoading = false
                this.requestUpdate();
            });
    }
}
